import { render, staticRenderFns } from "./ModalSelectConsultant.vue?vue&type=template&id=2d246d13&scoped=true"
import script from "./ModalSelectConsultant.vue?vue&type=script&lang=js"
export * from "./ModalSelectConsultant.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectConsultant.vue?vue&type=style&index=0&id=2d246d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d246d13",
  null
  
)

export default component.exports